.logbook-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.logbook-tab--empty {
  display: flex;
  padding-top: 1rem;
  align-items: center;
  justify-content: center;
  flex: 1;
}
.logbook-tab .HvEmptyState-titleContainer {
  margin: 0;
}

.logbook-header {
  padding: 0.7rem;
  border-bottom: 1px solid #cccccc;
}
.logbook-header span {
  font-weight: 400;
  font-size: 0.875rem;
  color: #666666;
}

.logbook-container {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.logbook-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.logbook-list-header {
  display: grid;
  grid-template-columns: 9rem 1fr 5rem;
  gap: 1rem;
  padding: 0.7rem 0.7rem 0;
  font-size: 0.75rem;
  font-weight: 600;
}

.logbook-list-body {
  flex: 1;
  overflow-y: auto;
}

.logbook-col {
  display: flex;
  align-items: center;
}
.logbook-col--notes {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.logbook-col--comments {
  justify-content: center;
}

.logbook-row {
  display: grid;
  grid-template-columns: 9rem 1fr 5rem;
  align-items: center;
  gap: 1rem;
  height: 2.6rem;
  padding: 0 0.7rem;
  border-bottom: 1px solid #cccccc;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background-color 0.15s ease;
}
.logbook-row:hover {
  background-color: rgb(95%, 95%, 95%);
}
.logbook-row--selected {
  background-color: rgb(90%, 90%, 90%);
}
.logbook-row--selected:hover {
  background-color: rgb(90%, 90%, 90%);
}
.logbook-row .logbook-col--notes {
  color: #333333;
}

.logbook-detail {
  width: 22rem;
  border-left: 1px solid #cccccc;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: expandWidth 0.3s ease-out;
}
.logbook-detail--closing {
  animation: collapseWidth 0.3s ease-in forwards;
}

@keyframes expandWidth {
  from {
    width: 0;
    opacity: 0;
  }
  to {
    width: 22rem;
    opacity: 1;
  }
}
@keyframes collapseWidth {
  from {
    width: 22rem;
    opacity: 1;
  }
  to {
    width: 0;
    opacity: 0;
  }
}
.logbook-detail-resolution {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem 1rem 1rem 1rem;
}

.logbook-detail-resolved {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.logbook-detail-date {
  font-weight: 600;
  font-size: 0.75rem;
}

.logbook-detail-user {
  display: flex;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
}
.logbook-detail-user > div {
  display: inline;
}

.logbook-detail-notes .no-content {
  color: #999999;
  font-style: italic;
  font-size: 0.875rem;
}

.read-more-text {
  font-size: 0.875rem;
  line-height: 1.5;
  color: #333333;
}
.read-more-text p {
  margin: 0;
}

.read-more-button {
  background: none;
  border: none;
  color: #3366ff;
  cursor: pointer;
  padding: 0;
  font-size: 0.875rem;
}
.read-more-button:hover {
  text-decoration: underline;
}

h4 {
  padding: 0.5rem 1rem 1rem;
}

.logbook-detail-comments {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.logbook-detail-comments h4 {
  margin: 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #cccccc;
  font-size: 0.875rem;
  font-weight: 600;
  color: #333333;
}

.comments-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.75rem;
  padding: 0.5rem 1rem 1rem;
}

.comments-list--empty {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.logbook-comment {
  display: flex;
  align-items: center;
}

.logbook-comment__badge {
  margin-right: 1rem;
}

.logbook-comment__content {
  flex: 1;
}

.logbook-comment__byline {
  display: flex;
  color: #666666;
  align-items: center;
  font-size: 0.875rem;
}
.logbook-comment__byline > :not(:last-child) {
  margin-right: 0.5rem;
}

.logbook-comment__body {
  font-size: 0.875rem;
  padding: 0.5rem;
  background-color: rgb(95%, 95%, 95%);
  white-space: pre-wrap;
  word-break: break-word;
}

.dark-theme .logbook-header {
  border-bottom-color: #333333;
}
.dark-theme .logbook-header span {
  color: rgb(50%, 50%, 50%);
}
.dark-theme .logbook-row {
  border-bottom-color: #333333;
}
.dark-theme .logbook-row:hover {
  background-color: #333333;
}
.dark-theme .logbook-row--selected {
  background-color: rgb(25%, 25%, 25%);
}
.dark-theme .logbook-row--selected:hover {
  background-color: rgb(25%, 25%, 25%);
}
.dark-theme .logbook-row .logbook-col--notes {
  color: rgb(50%, 50%, 50%);
}
.dark-theme .logbook-detail {
  border-left-color: #333333;
}
.dark-theme .logbook-detail-notes .no-content {
  color: #666666;
}
.dark-theme .read-more-text {
  color: rgb(90%, 90%, 90%);
}
.dark-theme .logbook-detail-comments h4 {
  color: rgb(50%, 50%, 50%);
  border-bottom-color: #333333;
}
.dark-theme .logbook-comment__byline {
  color: rgb(50%, 50%, 50%);
}
.dark-theme .logbook-comment__body {
  background-color: rgb(15%, 15%, 15%);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */